import { MONTH_BY_NUMBER, ROLES_SPANISH } from "./constants";
import truck from '../assets/images/Truck.png';
import pack from '../assets/images/Package.png';
import list from '../assets/images/list.png';
import client from '../assets/images/client.png';
import { enqueueSnackbar } from "notistack";
import z from "zod";


export const sortData = (data = [], column = '', direction = '') => {
  data === null ? data = [] : data;
  const shortData = [...data];
  return shortData.sort((a, b) => {
    let valueA = a[column] || '';
    let valueB = b[column] || '';

    // Detectar si los valores son numéricos y convertirlos para comparar
    const isNumericA = !isNaN(parseFloat(valueA)) && isFinite(valueA);
    const isNumericB = !isNaN(parseFloat(valueB)) && isFinite(valueB);

    if (isNumericA && isNumericB) {
      // Si ambos son números, compararlos numéricamente
      valueA = parseFloat(valueA);
      valueB = parseFloat(valueB);
    } else {
      // Si no son números, tratarlos como cadenas de texto
      valueA = valueA.toString();
      valueB = valueB.toString();
    }

    if (direction === 'asc') {
      return valueA > valueB ? 1 : -1;
    } else {
      return valueA < valueB ? 1 : -1;
    }
  });
};

export const countPreAlertInProgress = (operations = [], state = '', businessline = '') => operations.filter(operation => operation?.state.toLowerCase() === state.toLowerCase() && operation?.Businessline?.businessline_name.toLowerCase() === businessline.toLowerCase())?.length;


export const parseClientsOperations = (data) => {
  const result = data.reduce((acc, obj) => {
    const { responsible, state } = obj;

    if (!acc[responsible]) {
      acc[responsible] = { responsible, preAlert: 0, inProgress: 0 };
    }

    if (state === "Pre alerta") {
      acc[responsible].preAlert += 1;
    } else if (state === "En curso") {
      acc[responsible].inProgress += 1;
    }

    return acc;
  }, {});
  return Object.values(result);
}

// ------------------------ DATE ---------------------  
export const getDaysInMonth = (year = 2022, month = 1) => {
  year = +year;
  month = +month + 1;
  return new Date(year, month, 0).getDate();
};

const generateArray = (arrayLength = 0) => new Array(arrayLength).fill(1);

export const dayItems = (year, month) => {
  return generateArray(getDaysInMonth(year, month)).map((_element, index) => {
    return {
      value: index + 1,
      name: index + 1,
    };
  });
};

export const monthItems = () => generateArray(12).map((_element, index) => {
  const monthNumber = index + 1;
  return {
    value: monthNumber,
    name: MONTH_BY_NUMBER[monthNumber],
  };
});

export const yearItems = () => generateArray(100).map((_element, index) => {
  return {
    value: new Date().getFullYear() - index,
    name: new Date().getFullYear() - index,
  };
});

export const getIcon = (iconName) => {
  const icons = {
    truck,
    pack,
    list,
    client
  };
  return icons[iconName] || null;
}

export const getInitials = (name) => {
  if (!name) return '';
  return `${name.charAt(0)}`.toUpperCase();
};
export const errorAlert = (message, duration = 3000) => {
  enqueueSnackbar(message, {
    variant: "error",
    autoHideDuration: duration,
    anchorOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    style: {
      fontSize: "18px",
      fontWeight: 600,
    },
  });
};

export const successAlert = (message, duration = 3000) => {
  enqueueSnackbar(message, {
    variant: "success",
    autoHideDuration: duration,
    anchorOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    style: {
      fontSize: "18px",
      fontWeight: 600,
    },
  });
};

export const warningAlert = (message, duration = 3000) => {
  enqueueSnackbar(message, {
    variant: "warning",
    preventDuplicate: true,
    autoHideDuration: duration,
    anchorOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    style: {
      fontSize: "18px",
      fontWeight: 600,
      textAlign: "center",
      maxWidth: "600px",
    },
  });
};

export const schemaRegister = z.object({
    firstname: z.string()
        .min(1, "Nombre requerido")
        .regex(/^[A-Za-z\s]+$/, "Solo letras permitidas"),
    lastname: z.string()
        .min(1, "Apellido requerido")
        .regex(/^[A-Za-z\s]+$/, "Solo letras permitidas"),
    document: z.string()
        .min(1, "Documento requerido")
        .regex(/^\d+$/, "Solo números permitidos"),
    nit: z.string()
        .min(1, "NIT requerido")
        .regex(/^\d+$/, "Solo números permitidos"),
    email: z.string()
        .min(1, "Email requerido")
        .regex(/^[!#$%&'*+/0-9=?A-Z^a-z`{|}~]((_\._|\._\.|\._|_\.|\.|_)?[-!#$%&'*+/0-9=?A-Z^a-z`{|}~])*@[0-9A-Za-z]([-.]?[0-9A-Za-z])*\.[a-zA-Z](-?[a-zA-Z0-9]){1,2}$/,
            "Email inválido"),
    password: z.string()
        .min(1, "Contraseña requerida")
        .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+={}[\]:;"'<>,.?/~`|\\])[A-Za-z\d!@#$%^&*()_\-+={}[\]:;"'<>,.?/~`|\\]{8,}$/,
            "La contraseña debe tener mayúscula, minúscula, número y carácter especial"),
    confirmPassword: z.string()
        .min(1, "Confirmar contraseña requerida")
}).refine((data) => data.password === data.confirmPassword, {
    message: "Las contraseñas deben coincidir",
    path: ["confirmPassword"]
});

export const schemaRegisterCode = z.object({
    email: z.string()
      .min(1, "Email requerido")
      .regex(/^[!#$%&'*+/0-9=?A-Z^a-z`{|}~]((_\._|\._\.|\._|_\.|\.|_)?[-!#$%&'*+/0-9=?A-Z^a-z`{|}~])*@[0-9A-Za-z]([-.]?[0-9A-Za-z])*\.[a-zA-Z](-?[a-zA-Z0-9]){1,2}$/,
        "Email inválido"),

    code: z.string()
      .min(1, "Código requerido")
      .regex(/^\d+$/, "Solo números permitidos")
  });

  export const validateNewPassword = z.object({
    email: z.string()
      .min(1, "Email requerido")
      .regex(/^[!#$%&'*+/0-9=?A-Z^a-z`{|}~]((_\._|\._\.|\._|_\.|\.|_)?[-!#$%&'*+/0-9=?A-Z^a-z`{|}~])*@[0-9A-Za-z]([-.]?[0-9A-Za-z])*\.[a-zA-Z](-?[a-zA-Z0-9]){1,2}$/,
        "Email inválido"),
    newPassword: z.string()
      .min(8, "La contraseña debe tener al menos 8 caracteres")
      .regex(/[A-Z]/, "La contraseña debe contener al menos una letra mayúscula")
      .regex(/[a-z]/, "La contraseña debe contener al menos una letra minúscula")
      .regex(/[0-9]/, "La contraseña debe contener al menos un número")
      .regex(/[^A-Za-z0-9]/, "La contraseña debe contener al menos un símbolo especial"),
      confirmPassword: z.string()
      .min(1, "Confirmar contraseña requerida")
  }).refine((data) => data.newPassword === data.confirmPassword, {
    message: "Las contraseñas deben coincidir",
    path: ["confirmPassword"]
  });

  export const validateUserPassword = z.object({
    email: z.string()
    .min(1, "Email requerido")
    .regex(/^[!#$%&'*+/0-9=?A-Z^a-z`{|}~]((_\._|\._\.|\._|_\.|\.|_)?[-!#$%&'*+/0-9=?A-Z^a-z`{|}~])*@[0-9A-Za-z]([-.]?[0-9A-Za-z])*\.[a-zA-Z](-?[a-zA-Z0-9]){1,2}$/,
      "Email inválido"),
    password: z.string()
      .min(8, "Contraseña inválida. Intente de nuevo.")
      .regex(/[A-Z]/, "Contraseña inválida. Intente de nuevo.")
      .regex(/[a-z]/, "Contraseña inválida. Intente de nuevo.")
      .regex(/[0-9]/, "Contraseña inválida. Intente de nuevo.")
      .regex(/[^A-Za-z0-9]/, "Contraseña inválida. Intente de nuevo.")
  });

  export const validateUserInternalPassword = z.object({
    user:
    z.string()
    .min(1, "Usuario requerido")
    .regex(/^[^@]+$/, "El usuario no debe contener el símbolo '@'"),
    password: z.string()
  });

  export const ValidateCode = z.object({
    email: z.string()
      .min(1, "Email requerido")
      .regex(/^[!#$%&'*+/0-9=?A-Z^a-z`{|}~]((_\._|\._\.|\._|_\.|\.|_)?[-!#$%&'*+/0-9=?A-Z^a-z`{|}~])*@[0-9A-Za-z]([-.]?[0-9A-Za-z])*\.[a-zA-Z](-?[a-zA-Z0-9]){1,2}$/,
        "Email inválido"),
    password: z.string()
      .min(8, "La contraseña debe tener al menos 8 caracteres")
      .regex(/[A-Z]/, "La contraseña debe contener al menos una letra mayúscula")
      .regex(/[a-z]/, "La contraseña debe contener al menos una letra minúscula")
      .regex(/[0-9]/, "La contraseña debe contener al menos un número")
      .regex(/[^A-Za-z0-9]/, "La contraseña debe contener al menos un símbolo especial"),
    code: z.string()
      .length(6, "Debe contener 6 caracteres")
  });


  export const compareDate = (date1) => {
    const fecha1 = new Date(Number(date1));
    const fecha2 = new Date();
    if (fecha2.getTime() > fecha1.getTime())
      return { alert: true, refresh: true };
    const milisecondsAbs = Math.abs(fecha1 - fecha2);
    const days = Math.floor(milisecondsAbs / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (milisecondsAbs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((milisecondsAbs % (1000 * 60 * 60)) / (1000 * 60));
  
    if (days < 7)
      return {
        alert: true,
        data: `Tu contraseña vence en: ${days} días, ${hours} horas, ${minutes} minutos, puedes actualizarla desde el menú en la opción cambiar contraseña`,
      };
    return { alert: false };
  };

export const validateUserPasswordRecovery = z.object({
  email: z.string()
  .min(1, "Email requerido")
  .regex(/^[!#$%&'*+/0-9=?A-Z^a-z`{|}~]((_\._|\._\.|\._|_\.|\.|_)?[-!#$%&'*+/0-9=?A-Z^a-z`{|}~])*@[0-9A-Za-z]([-.]?[0-9A-Za-z])*\.[a-zA-Z](-?[a-zA-Z0-9]){1,2}$/,
    "Email inválido")
});

export const ValidateCodePassword = z.object({
  email: z.string()
  .min(1, "Email requerido")
  .regex(/^[!#$%&'*+/0-9=?A-Z^a-z`{|}~]((_\._|\._\.|\._|_\.|\.|_)?[-!#$%&'*+/0-9=?A-Z^a-z`{|}~])*@[0-9A-Za-z]([-.]?[0-9A-Za-z])*\.[a-zA-Z](-?[a-zA-Z0-9]){1,2}$/,
    "Email inválido"),
  password: z
    .string()
    .min(1, "Este campo es obligatorio.")
    .min(8, "Debe contener al menos 8 caracteres")
    .regex(/[A-Z]/, "Debe contener al menos una mayúscula")
    .regex(/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/, "Debe contener al menos un caracter especial"),
  code: z
    .string()
    .min(1, "Este campo es obligatorio.")
    .length(6, "Debe contener 6 caracteres"),
    confirmPassword: z
    .string()
    .min(1, "Este campo es obligatorio.")
  }).refine((data) => data.password === data.confirmPassword, {
    message: "Las contraseñas deben coincidir",
    path: ["confirmPassword"]
  });

export const getRolInSpanish = (rol = '') => {
  return ROLES_SPANISH[rol];
}